module.exports = __webpack_public_path__ + "img/b6e0c02.gif";